import {ContentFeed, ContentFeedType} from 'common/src/modules/contentFeeds/contentFeeds.types';

/** Use when tools cannot run because `contentFeedPage.feed` is missing, not AI-generated, or has no valid id. */
const CONTENT_FEED_AI_TOOL_CONTEXT_ERROR =
  'No active AI-generated content feed in the current page context . Open an AI-generated content feed so it is loaded before using this tool.';

function assertAiGeneratedContentFeed(
  feed: ContentFeed | null,
): feed is ContentFeed & {type: ContentFeedType.AiGenerated; id: number} {
  return (
    feed != null &&
    feed.type === ContentFeedType.AiGenerated &&
    typeof feed.id === 'number' &&
    feed.id > 0
  );
}

export default assertAiGeneratedContentFeed;
export {CONTENT_FEED_AI_TOOL_CONTEXT_ERROR};
